import MuiAppBar from '@mui/material/AppBar'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  padding: '0px',
  background: 'rgba(15, 23, 42, 0.8)',
  backdropFilter: 'blur(24px)',
  borderBottom: '1px solid rgba(168, 85, 247, 0.2)',
  boxShadow: '0 4px 24px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(168, 85, 247, 0.1)',
  position: 'static',
}))

const IconsWrapper = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
  gap: '8px',
}))

export const TopBarElements = {
  AppBar,
  IconsWrapper,
}